import { PaymentSystemPublic } from "@scrile/api-provider/dist/api/PaymentSystemsProvider";
export { default } from "./CCBill";

export const typeGuard = (system: PaymentSystemPublic | null): boolean => {
  return system?.type === "ccbill" ?? false;
};
